import * as React from 'react';

import { useTheme } from '@mui/material';
import { cn } from '../utils';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const {
      palette: { greyscaleLight },
    } = useTheme();
    return (
      <input
        type={type}
        style={{
          borderColor: greyscaleLight[300],
        }}
        className={cn(
          'flex h-11 w-full rounded-md hover:border hover:border-black border bg-transparent px-3 py-1 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
